import React from "react";
import "./ILike.css"

const ILike = () => {
    return(
        <div className="iLikeSection">
            <h3 className="sectionTitle">Me gusta ♥</h3>
            <p className="iLikeDescription">El Aprendizaje autónomo, hacer ejercicio, el deporte, escuchar música, los video juegos, convivir con mi familia y amigos.</p>
        </div>
    )
}
export default ILike